import { DealerTabSection, DealerTabState } from "@/components/DealerDetail/DealerTabState";
import { useApi } from "@/hooks/useApi";
import { formatCurrency, formatDate } from "@/lib/utils";
import { dealerService } from "@/services/DealerService";
import { RegistrationPlate } from "./RegistrationPlate";

const displayValue = (value: string | null): string => value?.trim() || "-";

export function DealsTab({ dealerId }: { dealerId: number }) {
  const { data, loading, error } = useApi((signal) => dealerService.getDealerDeals(dealerId, signal), [dealerId]);

  return (
    <DealerTabState data={data} loading={loading} error={error} label="deals" emptyMessage="No deals found for this dealer.">
      {(deals) => (
        <DealerTabSection title="Deals" count={deals.length}>
          <div className="overflow-x-auto">
            <table className="w-full min-w-max text-sm">
              <thead>
                <tr className="bg-muted/40 border-b text-left">
                  <th className="p-3 font-medium">Application ID</th>
                  <th className="p-3 font-medium">Customer</th>
                  <th className="p-3 font-medium">Registration</th>
                  <th className="p-3 font-medium">Lender</th>
                  <th className="p-3 text-right font-medium">Advance</th>
                  <th className="p-3 font-medium">Paid out</th>
                  <th className="p-3 font-medium">Agent</th>
                  <th className="p-3 font-medium">Dealer contact</th>
                </tr>
              </thead>
              <tbody>
                {deals.map((deal) => (
                  <tr key={deal.applicationId} className="border-b last:border-b-0">
                    <td className="p-3">{deal.applicationId}</td>
                    <td className="p-3 font-semibold">{displayValue(deal.customerName)}</td>
                    <td className="p-3">{RegistrationPlate({ reg: deal.vehicleRegistration })}</td>
                    <td className="p-3">{displayValue(deal.lender)}</td>
                    <td className="p-3 text-right">{deal.advance === null ? "-" : formatCurrency(deal.advance)}</td>
                    <td className="p-3">
                      {deal.paidOutDate ? formatDate(deal.paidOutDate) : <span className="text-muted-foreground">Not paid out</span>}
                    </td>
                    <td className="p-3">
                      <div>{displayValue(deal.agentName)}</div>
                      {deal.agentDepartment?.trim() && (
                        <div className="text-muted-foreground text-xs">{deal.agentDepartment}</div>
                      )}
                    </td>
                    <td className="p-3">{displayValue(deal.dealerContactName)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </DealerTabSection>
      )}
    </DealerTabState>
  );
}
